import React from "react";

export const BridgeHeader: React.FC = () => {
  return (
    <div className="text-center mb-6">
      <h1 className="text-2xl sm:text-4xl font-bold text-white font-roboto mb-2">
        A1X Bridge
      </h1>
      <p className="text-gray-400 text-sm sm:text-lg font-roboto px-4">
        Swap A1X tokens between Solana and MultiversX networks
      </p>
    </div>
  );
};